import Icon from "@common/controls/Icon/component";
import { IconType } from "@common/declarations";
import classNames from "classnames";
import * as React from "react";
import { type Courses } from "../../types";
import { getItemIcon } from "./lib";

export type MapProps = {
  isActive: boolean;
  item: Courses.ModuleLesson;
  completeIconType?: IconType;
};

export interface ActionProps {
  onClick: (id: string) => void;
}

export default ({ item, ...props }: ActionProps & MapProps) => (
  <div
    className={classNames("curriculum_item", { active: props.isActive, locked: item.isLocked })}
    onClick={item.isLocked ? undefined : () => props.onClick(item.id)}
  >
    <Icon className="type" icon={getItemIcon(item.programModuleLessonTypeKey)} />
    <span className="title">{item.title}</span>

    <span className="duration">{item.duration}</span>
    <div className={classNames("complete", { completed: item.isComplete })}>
      <Icon
        icon={
          item.isLocked
            ? IconType.Lock
            : item.isComplete
            ? props.completeIconType ?? IconType.CheckCircle
            : IconType.Circle
        }
      />
    </div>
  </div>
);
